

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _decode_entities = require('./decode_entities');

var _decode_entities2 = _interopRequireDefault(_decode_entities);

var _angular = require('angular');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Register entity decoding filter in Angular
_angular.$filterProvider.register('decodeEntities', _decode_entities2['default']);

// if an element has an ellipsis text-overflow in effect (it must already have
// the appropriate css styling) then invoke the function that is passed to the directive
function getVisibleWidth(elem) {
    var elemRect = elem.getBoundingClientRect();
    // cross browser, returns decimals for ultra-precision
    return elemRect.right - elemRect.left;
}

function getNaturalWidth(elem) {
    var old = {
        overflow: elem.style.overflow,
        width: elem.style.width,
        display: elem.style.display
    };
    var result;

    elem.style.overflow = 'visible';
    elem.style.width = 'auto';
    elem.style.display = 'inline-block';
    result = getVisibleWidth(elem);
    elem.style.overflow = old.overflow;
    elem.style.width = old.width;
    elem.style.display = old.display;

    return result;
}

// pre-determine approach to reading styles
var getStyle = _angular.$window.getComputedStyle ?
// modern browsers
function (elem, style) {
    return _angular.$window.getComputedStyle(elem)[style];
} :
// IE
function (elem, style) {
    return elem.currentStyle[style];
};

function hasEllipsis(elem) {
    var overflowHidden = getStyle(elem, 'overflow') === 'hidden';
    var textOverflowEllipsis = getStyle(elem, 'text-overflow') === 'ellipsis';
    var whiteSpaceNowrap = getStyle(elem, 'white-space') === 'nowrap';

    if (overflowHidden && textOverflowEllipsis && whiteSpaceNowrap) {
        return getVisibleWidth(elem) < getNaturalWidth(elem);
    }

    return false;
}

(0, _angular.$registerDirective)('onEllipsis', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            function invokeSubscriber() {
                (0, _angular.$parse)(attrs.onEllipsis)(scope);
                scope.$apply();
            }

            (0, _angular.$timeout)(function () {
                if (hasEllipsis(element[0])) {
                    invokeSubscriber();
                }
            });
        }

    };
});

// Makes an element examine the outerHeight of its siblings
// and the max-height of its parent, then sets a max-height for itself
// so that everything fits within the limits of the parent. Note that it assumes
// no other sibling also has dynamic-maxheight.
(0, _angular.$registerDirective)('dynamicMaxheight', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            function resizeContainer() {
                var $element = (0, _jquery2['default'])(element);
                var parentHeight = parseFloat(getStyle($element.parent()[0], 'max-height'));
                var siblings = $element.siblings().filter(function () {
                    var pos = getStyle((0, _jquery2['default'])(this)[0], 'position');
                    return pos !== 'fixed' && pos !== 'absolute';
                }).map(function getOuterHeights() {
                    return (0, _jquery2['default'])(this).outerHeight();
                });
                var siblingsHeight = 0;
                var i;

                for (i = 0; i < siblings.length; i += 1) {
                    siblingsHeight += siblings[i];
                }

                var spaceAvailable = parentHeight - siblingsHeight;

                if (!isNaN(spaceAvailable)) {
                    $element.css('max-height', spaceAvailable + 'px');
                }
            }

            // if an expression is provided, it is used as an event to listen for and recalculate the height
            if (attrs.dynamicMaxheight) {
                scope.$on((0, _angular.$parse)(attrs.dynamicMaxheight)(scope), resizeContainer);
            }

            (0, _angular.$timeout)(resizeContainer);
        }
    };
});

_angular.$registerDirective;

_angular.$filterProvider;

_angular.$parse;

_angular.$timeout;

_angular.$window;


//////////////////
// WEBPACK FOOTER
// ./components/xo-page-components/src/cart/lib/ui.js
// module id = ./components/xo-page-components/src/cart/lib/ui.js
// module chunks = 1